import { Location } from 'react-router-dom';

export const InvoiceConfigTabKeys = {
    GENERAL_SETTINGS: 'general-settings',
    ADDITIONAL_CHARGES: 'additional-charges',
} as const;

export type InvoiceConfigTabKey = typeof InvoiceConfigTabKeys[keyof typeof InvoiceConfigTabKeys];

export const getActiveInvoiceConfigTabKey = (location: Location) => {
    const segments = location.pathname.split('/').filter(Boolean);
    const last = segments[segments.length - 1] as InvoiceConfigTabKey;

    if (Object.values(InvoiceConfigTabKeys).includes(last)) {
        return last;
    }

    return InvoiceConfigTabKeys.GENERAL_SETTINGS;
};
